import React, {createContext, useContext} from 'react';
import {useTokenValue, tokens} from '@sail/ui';
import type {
  IPlatformViewportState,
  PlatformViewportStateValues,
} from './PlatformViewportState';

type Props = {
  platformViewportObserver: IPlatformViewportState;
};

type IPlatformViewportContext = {
  width: number;
  height: number;
  isMobileScreen: boolean;
};
export const PlatformViewportContext = createContext<IPlatformViewportContext>({
  width: 0,
  height: 0,
  isMobileScreen: false,
});

export const usePlatformViewport = () => useContext(PlatformViewportContext);

export const PlatformViewportProvider: React.FC<Props> = ({
  children,
  platformViewportObserver,
}) => {
  const [platformViewport, setPlatformViewport] =
    React.useState<PlatformViewportStateValues>(
      platformViewportObserver.values,
    );
  const smallScreenToken = useTokenValue(tokens.viewport.small);
  const smallScreenSize = parseInt(smallScreenToken, 10);

  React.useEffect(() => {
    const observer = () => {
      setPlatformViewport(platformViewportObserver.values);
    };
    platformViewportObserver.registerObserver(observer);
    return () => {
      platformViewportObserver.unregisterObserver(observer);
    };
  }, [platformViewportObserver]);

  return (
    <PlatformViewportContext.Provider
      value={{
        ...platformViewport,
        isMobileScreen: platformViewport.width <= smallScreenSize,
      }}
    >
      {children}
    </PlatformViewportContext.Provider>
  );
};
